<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

interface Emits {
  (event: 'closeModal'): void;
}

const emit = defineEmits<Emits>();

const onUIButtonClicked = async () => {
  await localStorage.setItem('isWelcomeTextModalSeen', '1');
  emit('closeModal');
};

const changesTexts = [
  'De ondernemershypotheek is nu ook toegevoegd aan het portaal',
  'Upload je documenten in het documentenbeheer op aanvraagniveau',
  'Bekijk alle automatisch verstuurde berichten op aanvraagniveau',
  'Zie direct of de actie bij jou of bij Mogelijk ligt',
  'Dit alles met een volledig nieuwe uitstraling',
];
</script>

<template>
  <div class="flex flex-col gap-6">
    <p class="text-base">
      We nemen je graag mee in de wijzigingen die we recent hebben doorgevoerd om bij te dragen aan het gebruiksgemak van dit portal:
    </p>

    <ul class="bg-gray-50 p-6 flex flex-col gap-6 rounded-xl text-base">
      <li
        v-for="(text, index) in changesTexts"
        :key="index"
        class="flex gap-2 items-center"
      >
        <FontAwesomeIcon :icon="['fas', 'circle-check']" class="text-green-700" />
        <span>{{ text }}</span>
      </li>
    </ul>

    <UIButton
      full-width
      data-test-id="close-welcometext-modal-button"
      class="mb-14 sm:mb-0"
      @click="onUIButtonClicked()"
    >
      Ontdek nu
      <template #icon-end>
        <FontAwesomeIcon :icon="['fas', 'arrow-right']" />
      </template>
    </UIButton>
  </div>
</template>
